import type { ContentfulCardFragment } from '@/graphql/contentful/api';

import * as S from './CTA.styles';

export const Cta = ({
  onClick,
  url,
  urlText,
}: Pick<ContentfulCardFragment, 'url' | 'urlText' | 'urlType'> & {
  onClick?: () => void;
}) => {
  if (!urlText) {
    return null;
  }

  return (
    <S.Button
      colorVariant='primary'
      data-test-id='CtaButton'
      label={urlText}
      linkProps={{ href: url ?? '#' }}
      onClick={onClick}
      variant='link'
    >
      <S.Chevron data-test-id='CtaChevron' height={24} />
    </S.Button>
  );
};
